import { FC } from 'react';
import { Container, Title, Subtitle, Btn } from './UploadErrorNotification.styles';
import { UploadProgressStrings } from '../../localization/en';
import { PortalWrapper } from '../PortalWrapper/PortalWrapper';

interface Props {
  onRestartClick: () => void;
}

export const UploadErrorNotification: FC<Props> = ({ onRestartClick }) => {
  return (
    <PortalWrapper>
      <Container>
        <Title color={'#475467'}>
          {UploadProgressStrings.Hmmm}
        </Title>
        <Title mt="20px" color={'#2D11AD'}>
          {UploadProgressStrings.uploadInterrupted}
        </Title>
        <Subtitle color={'#475467'}>
          {UploadProgressStrings.TapResume}
        </Subtitle>
        <Btn onClick={onRestartClick}>
          {UploadProgressStrings.RestartUploadButton}
        </Btn>
      </Container>
    </PortalWrapper>
  );
};
